const firebaseConfig = {
    apiKey: "AIzaSyCTRhy6azIK2xLECrIaW7uJpQjcXff7vy4",
    authDomain: "blood-donation-7fb25.firebaseapp.com",
    projectId: "blood-donation-7fb25",
    storageBucket: "blood-donation-7fb25.appspot.com",
    messagingSenderId: "533714355228",
    appId: "1:533714355228:web:6c74b059fd8d8035344bd9"
};

export default firebaseConfig;